//import {getEwCompanies} from '../enterworks'
export const FETCH_EWCOMPANIES_BEGIN = "FETCH_EWCOMPANIES_BEGIN"
export const FETCH_EWCOMPANIES_SUCCESS ="FETCH_EWCOMPANIES_SUCCESS"
export const FETCH_EWCOMPANIES_FAILURE = "FETCH_EWCOMPANIES_FAILURE"
export const SET_EWCOMPANY_SELECT = "SET_EWCOMPANY_SELECT"
export const TOGGLE_SHOW = 'TOGGLE_SHOW'
export const CLEAR_COS = "CLEAR_COS"

//actions

const cCos = index =>({
  type : CLEAR_COS,
  payload : {index}
})
const fetchEwCompaniesBegin = () => ({
    type: FETCH_EWCOMPANIES_BEGIN
  });
  
const fetchEwCompaniesSuccess = companies => ({
    type: FETCH_EWCOMPANIES_SUCCESS,
    payload: { companies }
  });
  
const fetchEwCompaniesFailure = error => ({
    type: FETCH_EWCOMPANIES_FAILURE,
    payload: { error }
  });

const toggleShow = () => ({type : TOGGLE_SHOW})

 const setEWCoSelect = (company, index) => ({
    type: SET_EWCOMPANY_SELECT,
    payload: { company, index }
  });

  //action creators
  
  export function clearCos(index){
    return cCos(index)
  }
  
  export function selectEwCompany(company, index){
    return setEWCoSelect(company, index)
}
export function toggleShowModal(){
  return toggleShow()
}

export function fetchEwCompanies() {
    return dispatch => {
      dispatch(fetchEwCompaniesBegin());
      return getEwCompanies()
        .then(json => {
          dispatch(fetchEwCompaniesSuccess(json));
          return json;
        })
        .catch(error =>
          dispatch(fetchEwCompaniesFailure(error))
        );
    };
  }

  // api calls

  function getEwCompanies(){
    return fetch("/iframeApi/companies")
    .then(handleErrors)
    .then(res => res.json());
  }

  function handleErrors(response) {
    if (!response.ok) {
      throw Error(response.statusText);
    }
    return response;
  }
  